import { doorQueryKeys, type DoorQueryKeys, type QueryKeyPart } from "@sx/api-client";
import { useCallback } from "react";

import type { ConsoleDoorId } from "../platform.gen";
import { usePrincipalId } from "./browser-state";

const keys = <Door extends ConsoleDoorId>(door: Door) => doorQueryKeys(door);

export const authQueryKeys = keys("auth");
export const autonomyQueryKeys = keys("autonomy");
export const catalogQueryKeys = keys("catalog");
export const factoryQueryKeys = keys("factory");
export const fleetQueryKeys = keys("fleet");
export const labelerQueryKeys = keys("labeler");
export const waddleQueryKeys = keys("waddle");
export const worldsQueryKeys = keys("worlds");

export const attachedOperationQueryKey = (
  owner: ConsoleDoorId,
  projectId: string,
  operationRef: string,
) => keys(owner).project(projectId, "attached-operation", operationRef);

export type PrincipalQueryKey = (...parts: readonly QueryKeyPart[]) => readonly QueryKeyPart[];

const usePrincipalKey = <Door extends ConsoleDoorId>(
  factory: DoorQueryKeys<Door>,
): PrincipalQueryKey => {
  const principalId = usePrincipalId();
  return useCallback((...parts) => factory.principal(principalId, ...parts), [factory, principalId]);
};

export const useAuthQueryKey = (): PrincipalQueryKey => usePrincipalKey(authQueryKeys);
export const useFactoryQueryKey = (): PrincipalQueryKey => usePrincipalKey(factoryQueryKeys);
export const useFleetQueryKey = (): PrincipalQueryKey => usePrincipalKey(fleetQueryKeys);
